module.exports = __webpack_public_path__ + "static/media/menu-icon~ITnySXdy.0682799f.svg";